/**
 * Sign out.
 *
 * The existing application used a Next server action; here it is an ordinary
 * request. The session cookie is HTTP-only either way, so the browser never
 * touches it — the server clears it.
 */
export async function logout(): Promise<void> {
  await fetch("/api/auth/sign-out", { method: "POST", credentials: "include" });
  window.location.assign("/login");
}
